export default __webpack_public_path__ + "static/media/south-korea.037a037f.svg";